import $ from 'jquery'
import PhotoSwipe from '@PhotoSwipe'
import PhotoSwipeLightbox from '@PhotoSwipeLightbox'

import '../../../scss/app/portfolio_item.scss'

window.APP.itemPhotos = window.APP.itemPhotos || []

const photoswipePhotos = window.APP.itemPhotos.map((photo) => ({
  src: window.APP.context.site.files_url + photo.path,
  w: photo.width,
  h: photo.height,
  title: photo.title,
  description: photo.description,
}))

const photoswipeOptions = {
  bgOpacity: 1,
  pswpModule: PhotoSwipe,
  dataSource: photoswipePhotos,
  paddingFn: (viewportSize) => ({
    top: viewportSize.y > 768 ? 100 : 0,
    bottom: viewportSize.y > 768 ? 100 : 0,
    left: 0,
    right: 0,
  }),
}

const lightbox = new PhotoSwipeLightbox(photoswipeOptions)

const $images = $('.item__image')
$images.on('click', (ev) => {
  ev.preventDefault()
  lightbox.loadAndOpen($images.index(ev.currentTarget))
})
